import iziToast from "izitoast"

import "izitoast/dist/css/iziToast.css"
import "izitoast/dist/css/iziToast.min.css"

export default defineNuxtPlugin(() => {
	iziToast.settings({
		resetOnHover: true,
		position: "bottomLeft",
		timeout: 5000
	})
	return {
		provide: {
			toast: iziToast
		}
	}
})
